import { ISnackbarMessage } from '../constants/types';
import SnackbarContext from '../context/SnackbarContext';
import { useState } from 'react';

let globalShowSnackbar: ((message: ISnackbarMessage) => void) | undefined;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SnackbarProvider = ({ children }: any) => {
  const [snackbarMessage, setSnackbarMessage] =
    useState<ISnackbarMessage | null>(null);

  const showSnackbar = (message: ISnackbarMessage) => {
    setSnackbarMessage(message);
  };

  const hideSnackbar = () => {
    setSnackbarMessage(null);
  };

  // Expose the showSnackbar function globally
  globalShowSnackbar = showSnackbar;

  return (
    <SnackbarContext.Provider
      value={{ snackbarMessage, showSnackbar, hideSnackbar }}
    >
      {children}
    </SnackbarContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const triggerSnackbar = (message: ISnackbarMessage) => {
  if (globalShowSnackbar) {
    globalShowSnackbar(message);
  } else {
    console.warn('Snackbar is not initialized.');
  }
};
